import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};

var SpeechBubbleText = function SpeechBubbleText(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return React.createElement('svg', {
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement('path', {
    d: 'M7 12H17M7 8H13M3 20.2895V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15C21 16.1046 20.1046 17 19 17H7.96125C7.35368 17 6.77906 17.2762 6.39951 17.7506L4.06852 20.6643C3.71421 21.1072 3 20.8567 3 20.2895Z',
    stroke: color,
    strokeWidth: '1.5',
    strokeLinecap: 'round'
  }));
};

SpeechBubbleText.propTypes = propTypes;
export default SpeechBubbleText;